export const services = [
    {
        name: "Level 1",
        features: ["Weekly custom plans in monthly blocks", "Daily analysis and review of workouts via text/email", "Weekly phone recap of workouts and goals", "Video analysis of workouts", "Nutrition assistance", "Equipment assistance"]
    },
    {
        name: "Level 2",
        features: ["4 week block of plans", "Monthly analysis of workouts via text/email", "Monthly phone recap to discuss workouts and goals", "Nutrition assistance", "Equipment assistance"]
    }
]